import { create } from 'zustand';

interface DocumentTitleStore {
  pageTitle: string | null;
  setPageTitle: (title: string) => void;
}

export const useDocumentTitleStore = create<DocumentTitleStore>((set) => ({
  pageTitle: null,
  setPageTitle: (pageTitle) => set({ pageTitle }),
}));
